import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/mobileUtils.css'; // Import mobile utilities
import './styles/mobile-buttons.css'; // Import mobile button styles
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorker } from './serviceWorkerRegistration';
import { captureInstallPrompt } from './services/offline/platform/installPrompt';

// Phase 16A: catch Chromium's one-time install event before React mounts (login Install button)
captureInstallPrompt();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Phase 16A: app shell for the installed app and offline launch (production builds only)
registerServiceWorker();
